import { VASTAdsMixin } from './vast-hls-video.js';
import BunnyStreamVideoElement from './components/bunny-stream-video.js';

class BunnyStreamVideoVast extends VASTAdsMixin(BunnyStreamVideoElement) {}

customElements.define('bunny-stream-video-vast', BunnyStreamVideoVast, {
  extends: 'video',
});

export default BunnyStreamVideoVast;
